var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPresentation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 44,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 2.5,
  clipPath: "url(#svg-public/img/unlimited-docs/banner/presentation.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M124.5 36.037c42.11-4.385 108 .07 108 .07M242.951 13.932c1.431-.796 4.493-2.637 6.363-3.677M245.151 19.111l4.444.39M238.721 10.17l.657-4.413"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/unlimited-docs/banner/presentation.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h256v44H0z"
})))));
export { SvgPresentation as ReactComponent };